import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { SizeMe } from 'react-sizeme';
import { Icon, Text } from '../../../ui-kit';
import mediaSizes from '../../../common/constants/mediaSizes';
import getSubscriptionInfoFromContract from '../../../common/utils/getSubscriptionInfoFromContract';
import '../styles/_subscriptionInfo.scss';

const LINE_COLORS = {
  Paid: '#27baa1',
  Trial: '#27baa1',
  Free: '#d4d9e2'
};

const TIER_COLORS = {
  Paid: '#27baa1',
  Trial: '#f69f1f',
  Free: '#d4d9e2'
};

const ICON_NAMES = {
  Pro: 'procolor',
  Elevate: 'elevatecolor',
  Cast: 'castdef'
};






export default function SubscriptionInfo(props) {
  const { getContracts, organisationId } = props;

  const [contractsData, setContractsData] = useState({});

  if (!getContracts) {return null;}

  const fetchData = async () => {
    const fetchedContractsData = await getContracts({ organisationId, status: 'ACTIVE' });
    setContractsData(fetchedContractsData);
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!contractsData ||
  !contractsData.data ||
  !contractsData.data.getContracts.length)
  {
    return null;
  }

  const contracts = contractsData.data.getContracts.reverse();

  const allSubscriptions = contracts.map((contract) => getSubscriptionInfoFromContract(contract));

  const subscriptions = allSubscriptions.filter((contract) => contract.name !== 'Workspace');

  return (
    <SizeMe>
      {({ size: { width } }) =>
      <div
        className={cx(
          'subscription-info',
          { 'subscription-info--medium': width < mediaSizes.medium },
          { 'subscription-info--small': width < mediaSizes.small }
        )}>

          {subscriptions.map((subscription) =>
        <div
          className="subscription-info__line-box"
          style={{ borderColor: LINE_COLORS[subscription.tier] }}
          key={subscription.key}>

              <div className="subscription-info__line-box__left">
                <Icon name={ICON_NAMES[subscription.name]} size={35} />
                <div className="subscription-info__line-box__left__text">
                  <div className="subscription-info__line-box__left__text__title">
                    <Text
                  heading5
                  className="subscription-info__line-box__left__text__title__product">

                      {subscription.name}
                    </Text>
                    <Text
                  className="subscription-info__line-box__left__text__title__tier">

                      <span style={{ background: TIER_COLORS[subscription.tier] }}>
                        {subscription.tier}
                      </span>
                    </Text>
                  </div>
                  <Text>{subscription.info}</Text>
                </div>
              </div>
              <div className="subscription-info__line-box__right">
                <Text heading5 className="subscription-info__line-box__right__title">
                  Subscription Ends
                </Text>
                <Text>{subscription.endDate}</Text>
              </div>
            </div>
        )}

        </div>}

    </SizeMe>);

}